module.exports = __webpack_public_path__ + "img/upload-blue-icon.bcecb8e4.svg";